<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card no-body header-classes="bg-transparent">
            <b-card-header>
              <h2 slot="header" class="mb-0">สร้างลูกค้า</h2>
            </b-card-header>
            <!-- <b-row class="mb-4">
              <b-col cols="12" class="mb-4">
                <h2 slot="header" class="mb-0">สร้างลูกค้า</h2>
              </b-col>
            </b-row> -->
            <b-card-body>
              <b-row class="mb-4">
                <b-col lg="12" class="my-2">
                  <h4 class="text-muted">ข้อมูลลูกค้า</h4>
                </b-col>
              </b-row>
              <ValidationObserver ref="observer">
                <b-form @submit="onSubmit">
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ชื่อร้านค้า/บริษัท">
                          <b-form-input
                            v-model="form.shop_name"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ชื่อ">
                          <b-form-input
                            v-model="form.firstname"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="นามสกุล">
                          <b-form-input
                            v-model="form.lastname"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="อีเมล์">
                          <b-form-input
                            v-model="form.email"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="เบอร์โทรศัพท์">
                          <b-form-input
                            v-model="form.phonenumber"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <b-row>
                    <b-col lg="12" class="my-2">
                      <h4 class="text-muted">เส้นทางตั้งต้น</h4>
                      <small class="text-warning">
                        <i class="fas fa-exclamation-circle"></i>
                        หากคุณสร้างเส้นทางตั้งต้น รายการนี้จะถูกดึงไปใช้ในหน้าสร้างงานได้
                      </small>
                    </b-col>
                    <b-col lg="12" class="card-border-radius px-0 my-2">
                      <JobRoute :form="form"/>
                    </b-col>
                  </b-row>
                  <hr class="my-4" />
                  <div class="d-flex justify-content-between">
                    <base-button
                      type="secondary"
                      class=""
                      @click="confirmAndGoBack"
                    >
                      ย้อนกลับ
                    </base-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      :disabled="isLoading"
                      class="w-25"
                      >บันทึก</b-button
                    >
                  </div>
                </b-form>
              </ValidationObserver>
            </b-card-body>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import customerServices from "@/api/customer.service.js";
import JobRoute from "@/views/Pages/Admin/Job/components/JobRoute.vue";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    JobRoute
  },
  data() {
    return {
      isLoading: false,
      form: {
        shop_name: "",
        firstname: "",
        lastname: "",
        email: "",
        phonenumber: "",
        categoryRoutes: []
      },
    };
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      const customerData = {
        shop_name: this.form.shop_name,
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        email: this.form.email,
        phonenumber: this.form.phonenumber,
        customer_routes: this.form.categoryRoutes.map( item => {
          return {
            name: item.name,
            customer_route_details: [...item.routes]
          }
        })
      };

      try {
        this.isLoading = true;
        const response = await customerServices.createCustomer(customerData);

        this.$refs.observer.reset();
        this.form = {
          shop_name: "",
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          customer_routes: []
        };

        modalSuccess(this.$bvModal, 'สร้างลูกค้าสำเร็จ').then( () => {
          this.$router.push({
            name: "manageCustomer",
          });
        })
      } catch (error) {
        // จัดการกับข้อผิดพลาดในกรณีที่เกิดข้อผิดพลาดในการโพสต์ข้อมูล
        modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
        console.error("Error creating customer", error);
      } finally {
        this.isLoading = false;
      }
    },
    confirmAndGoBack() {
      // ใช้ window.confirm เพื่อแสดงกล่องยืนยัน
      if (window.confirm("คุณต้องการที่จะย้อนกลับหรือไม่?")) {
        // ถ้าผู้ใช้ยืนยัน ให้ใช้ router.go(-1) เพื่อย้อนกลับ
        this.$router.go(-1);
      } else {
        // ถ้าผู้ใช้ยกเลิก ไม่ต้องทำอะไร
      }
    },
  },
};
</script>
